import { CountryFlag, SequenceNumber, Text } from '@reveni-io/reveni-ui'

import CustomsChip from '@/parcels/components/CustomsChip/CustomsChip'
import InternationalChip from '@/parcels/components/InternationalChip/InternationalChip'
import ParcelCheckbox from '@/parcels/components/ParcelCheckbox/ParcelCheckbox'
import ParcelTrackingNumber from '@/parcels/components/ParcelTrackingNumber/ParcelTrackingNumber'
import ParcelTypeChip from '@/parcels/components/ParcelTypeChip/ParcelTypeChip'
import { isInternationalAddresses } from '@/parcels/helpers/helpers'
import ParcelStatus from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/ParcelStatus/ParcelStatus'

import * as Styles from './styles'

const ParcelCardHeader = ({
  orderName,
  withCustoms,
  senderAddress,
  recipientAddress,
  trackingNumber,
  trackingUrl,
  status,
  selected,
  onSelect,
  sequenceInfo,
  type,
  isExchange,
}) => {
  const isInternational = isInternationalAddresses(senderAddress, recipientAddress)

  return (
    <Styles.HeaderContainer>
      <Styles.HeaderLeftContainer>
        <ParcelCheckbox selected={selected} onSelect={onSelect} />
        <Styles.HeaderLeftInfoContainer>
          <Text type="titleM">{orderName}</Text>
          {sequenceInfo && <SequenceNumber position={sequenceInfo.position} total={sequenceInfo.total} />}
          <ParcelTypeChip type={type} isExchange={isExchange} />
          {isInternational && <InternationalChip />}
          {withCustoms && <CustomsChip />}
          <CountryFlag code={senderAddress?.country?.code} />
          {isInternational && <CountryFlag code={recipientAddress?.country?.code} />}
        </Styles.HeaderLeftInfoContainer>
      </Styles.HeaderLeftContainer>
      <Styles.HeaderRightContainer>
        <ParcelTrackingNumber trackingNumber={trackingNumber} trackingUrl={trackingUrl} />
        <ParcelStatus status={status} />
      </Styles.HeaderRightContainer>
    </Styles.HeaderContainer>
  )
}

export default ParcelCardHeader
